import { createSlice } from '@reduxjs/toolkit';
import { RootState } from '../store';

// Define the initial state using that type
const initialState: any = {
  alertsStore: [],
  priorityMessage: {
    message: null,
    showPriorityMessage: true,
  }
};

export const alertsSlice = createSlice({
  name: 'alertsSlice',
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    updateAlerts: (state, action) => {
      state.alertsStore = action.payload;
    },
    updatePriorityMessage: (state, action) => {
      state.priorityMessage.message = action.payload;
      state.priorityMessage.showPriorityMessage = true;
    },
    updateShowPriorityMessage: (state, action) => {
      state.priorityMessage.showPriorityMessage = action.payload;
    },
  },
});

export const { updateAlerts, updatePriorityMessage, updateShowPriorityMessage } = alertsSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const alertsState = (state: RootState) => state.alerts.alertsStore;
export const priorityMessageState = (state: RootState) => state.alerts.priorityMessage;

export default alertsSlice.reducer;
